import { Link } from 'react-router-dom';
import {
  Breadcrumb as BreadcrumbUI,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { Vehicle } from '@/types';
import { generateBreadcrumbSchema } from '@/utils/seoHelpers';
import { Helmet } from 'react-helmet-async';

interface BreadcrumbProps {
  vehicle: Vehicle;
}

const getCategoryLabel = (category: Vehicle['category']): string => {
  const labels: Record<Vehicle['category'], string> = {
    'camion': 'Camions',
    'materiel-industriel': 'Matériel industriel',
    'utilitaire': 'Utilitaires',
    'remorque': 'Remorques',
    'autre': 'Autres',
  };
  return labels[category] || category;
};

export const VehicleBreadcrumb = ({ vehicle }: BreadcrumbProps) => {
  const categoryLabel = getCategoryLabel(vehicle.category);
  
  // Générer le schéma JSON-LD pour les breadcrumbs
  const breadcrumbItems = [
    { name: 'Accueil', url: 'https://trucks52-sarl.lovable.app/' },
    { name: categoryLabel, url: `https://trucks52-sarl.lovable.app/?category=${vehicle.category}` },
  ];

  if (vehicle.brand) {
    breadcrumbItems.push({
      name: vehicle.brand,
      url: `https://trucks52-sarl.lovable.app/?brand=${vehicle.brand}`,
    });
  }

  breadcrumbItems.push({
    name: vehicle.title,
    url: window.location.href,
  });

  const breadcrumbSchema = generateBreadcrumbSchema(breadcrumbItems);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      
      <BreadcrumbUI className="mb-6">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Accueil</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to={`/?category=${vehicle.category}`}>{categoryLabel}</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          
          {vehicle.brand && (
            <>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to={`/?brand=${vehicle.brand}`}>{vehicle.brand}</Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
            </>
          )}
          
          <BreadcrumbItem>
            <BreadcrumbPage className="max-w-[200px] truncate sm:max-w-none">
              {vehicle.title}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </BreadcrumbUI>
    </>
  );
};
